/** ----------------------------------------------------------------------------------------------------
 *  State to keep track of if banner or button should be displayed.
 *  --------------------------------------------------------------------------------------------------*/
export default {
  answer_given: false,
}
